import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Components
import FloatingPanel from './FloatingPanel';
import ShortcutKeyGroup from '../../workspace/shortcuts/ShortcutKeyGroup';

const mapStateToProps = (state) => ({
    tooltip: state.getIn(['app', 'tooltip']),
});

const WorkspaceTooltipManager = ({ tooltip, mountPointSelector }) => {
    const content = tooltip.get('content');

    if (!content) return null;

    const shortcut = content.get('shortcut');

    return (
        <FloatingPanel
            key={content.get('selector')}
            selector={content.get('selector')}
            position={content.get('position')}
            distance={content.get('distance')}
            offset={content.get('offset')}
            arrowOffset={content.get('arrowOffset')}
            delay={content.get('delay')}
            duration={content.get('duration')}
            targetRect={content.get('targetRect')}
            pollPosition={content.get('pollPosition')}
            className={content.get('className') || 'small'}
            fade={content.get('fade')}
            hideOnEvent={content.get('hideOnEvent')}
            mountPointSelector={mountPointSelector}
        >
            <div className="primary-text">
                {content.get('text')}
                <ShortcutKeyGroup shortcut={shortcut} preferSymbol />
            </div>
        </FloatingPanel>
    );
};

WorkspaceTooltipManager.propTypes = {
    tooltip: PropTypes.object,
    mountPointSelector: PropTypes.string,
};

export default connect(mapStateToProps)(WorkspaceTooltipManager);
